
import { read, utils } from "xlsx";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      file: null,
      rawData: [],
      hover: false
    };
  },
  computed: {
    ...mapState("menu", ["menuUploadRawData"]),
    getButtonText() {
      return this.file ? "Change File" : "Upload Menu ";
    }
  },

  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_RAW_DATA"]),
    async fileChanged(e) {
      this.file = e.target.files[0];
      if (this.file) {
        this.$emit("reset-store", true);
        const data = await this.file.arrayBuffer();
        /* data is an ArrayBuffer */
        const workbook = read(data);
        const ws = workbook.Sheets[workbook.SheetNames[0]]; // get the first worksheet
        const jsondata = utils.sheet_to_json(ws); // generate objects
        const rows = [
          Object.keys(jsondata[0]),
          ...jsondata.map((el) => Object.values(el))
        ]; // convert to array
        // Skip initial empty rows
        const filteredRows = rows.filter((row) =>
          row.some((cell) => cell !== null && cell !== "")
        );

        // Get the first non-empty row (0th indexed row)
        const firstNonEmptyRow = filteredRows[0];

        // Filter columns based on non-empty values in the 0th indexed row
        const cleanedData = filteredRows.map((row) =>
          row.filter(
            (cell, index) =>
              firstNonEmptyRow[index] !== null && firstNonEmptyRow[index] !== ""
          )
        );

        this.SET_MENU_UPLOAD_RAW_DATA(cleanedData);
        this.$router.push("/menu/upload");
      }
    }
  }
};
